export default __webpack_public_path__ + "static/media/image_full_100.dceec7c7.svg";